import { render, staticRenderFns } from "./SendBusinessCardModal.vue?vue&type=template&id=457f1c9e&scoped=true&"
import script from "./SendBusinessCardModal.vue?vue&type=script&lang=js&"
export * from "./SendBusinessCardModal.vue?vue&type=script&lang=js&"
import style0 from "./SendBusinessCardModal.vue?vue&type=style&index=0&id=457f1c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f1c9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardActions,VCardSubtitle,VCardText,VCol,VDialog,VRow,VToolbar,VToolbarTitle})
